import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "app-container min-h-screen bg-gray-900" }
const _hoisted_2 = { class: "bg-gray-800 shadow-lg border-b border-gray-700 w-full relative z-50" }
const _hoisted_3 = { class: "w-full max-w-full px-3 sm:px-4 md:px-6 lg:px-8" }
const _hoisted_4 = { class: "flex items-center justify-between h-14 sm:h-16" }
const _hoisted_5 = { class: "flex items-center space-x-2 sm:space-x-4 md:space-x-8 flex-1 min-w-0" }
const _hoisted_6 = { class: "hidden sm:flex items-center space-x-2 md:space-x-4" }
const _hoisted_7 = { class: "flex items-center space-x-1 sm:space-x-2 md:space-x-4 flex-shrink-0" }
const _hoisted_8 = {
  key: 1,
  class: "flex items-center space-x-1 sm:space-x-2"
}
const _hoisted_9 = {
  key: 0,
  class: "hidden md:block text-gray-300 text-sm truncate max-w-[120px]"
}
const _hoisted_10 = { class: "sm:hidden border-t border-gray-700 py-2" }
const _hoisted_11 = { class: "flex items-center justify-between space-x-2 px-3" }
const _hoisted_12 = { class: "flex-grow py-6" }
const _hoisted_13 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" }
const _hoisted_14 = {
  key: 1,
  class: "flex justify-center items-center min-h-[50vh]"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SidebarMenu = _resolveComponent("SidebarMenu")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_AppFooter = _resolveComponent("AppFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SidebarMenu),
    _createElementVNode("div", {
      class: _normalizeClass(["content-container transition-all duration-300 flex flex-col", [_ctx.isSidebarOpen ? 'with-sidebar-open' : 'with-sidebar-closed']])
    }, [
      _createElementVNode("nav", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_router_link, {
                to: "/",
                class: "text-white font-bold text-lg sm:text-xl hover:text-indigo-400 transition-colors flex-shrink-0 flex items-center space-x-2"
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createElementVNode("img", {
                    src: _imports_0,
                    alt: "Logo",
                    class: "h-12 sm:h-12"
                  }, null, -1),
                  _createElementVNode("span", null, "Moja Garderoba", -1)
                ])),
                _: 1
              }),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_router_link, {
                  to: "/products",
                  class: "text-gray-300 hover:text-white px-2 md:px-3 py-2 rounded-md text-xs sm:text-sm font-medium transition-colors whitespace-nowrap"
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode(" Proizvodi ")
                  ])),
                  _: 1
                }),
                (_ctx.isLoggedIn)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: "/create-product",
                      class: "bg-indigo-600 hover:bg-indigo-700 text-white px-2 md:px-3 py-2 rounded-md text-xs sm:text-sm font-medium transition-colors flex items-center space-x-1 md:space-x-2 whitespace-nowrap"
                    }, {
                      default: _withCtx(() => _cache[3] || (_cache[3] = [
                        _createElementVNode("svg", {
                          xmlns: "http://www.w3.org/2000/svg",
                          class: "h-4 w-4",
                          viewBox: "0 0 20 20",
                          fill: "currentColor"
                        }, [
                          _createElementVNode("path", {
                            "fill-rule": "evenodd",
                            d: "M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z",
                            "clip-rule": "evenodd"
                          })
                        ], -1),
                        _createElementVNode("span", null, "Dodaj novi oglas", -1)
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              (!_ctx.isLoggedIn)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_router_link, {
                      to: "/login",
                      class: _normalizeClass(["text-gray-300 hover:text-white px-2 sm:px-3 py-1 sm:py-2 rounded-md text-xs sm:text-sm font-medium transition-colors whitespace-nowrap", { 'bg-gray-900': _ctx.$route.path === '/login' }])
                    }, {
                      default: _withCtx(() => _cache[4] || (_cache[4] = [
                        _createTextVNode(" Prijava ")
                      ])),
                      _: 1
                    }, 8, ["class"]),
                    _createVNode(_component_router_link, {
                      to: "/register",
                      class: "bg-indigo-600 hover:bg-indigo-700 text-white px-2 sm:px-4 py-1 sm:py-2 rounded-md text-xs sm:text-sm font-medium transition-colors whitespace-nowrap"
                    }, {
                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                        _createTextVNode(" Registracija ")
                      ])),
                      _: 1
                    })
                  ], 64))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    (_ctx.currentUser)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.currentUser.username || _ctx.currentUser.email), 1))
                      : _createCommentVNode("", true),
                    (_ctx.currentUser)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 1,
                          to: `/profile/${_ctx.currentUser.id}`,
                          class: _normalizeClass(["text-gray-300 hover:text-white px-2 sm:px-3 py-1 sm:py-2 rounded-md text-xs sm:text-sm font-medium transition-colors whitespace-nowrap", { 'bg-gray-900': _ctx.$route.path === '/profile' }])
                        }, {
                          default: _withCtx(() => _cache[6] || (_cache[6] = [
                            _createTextVNode(" Profil ")
                          ])),
                          _: 1
                        }, 8, ["to", "class"]))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
                      class: "text-gray-300 hover:text-white px-2 sm:px-3 py-1 sm:py-2 rounded-md text-xs sm:text-sm font-medium transition-colors whitespace-nowrap"
                    }, " Odjava ")
                  ]))
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_router_link, {
                to: "/products",
                class: "text-gray-300 hover:text-white py-2 rounded-md text-sm font-medium transition-colors flex-1"
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createTextVNode(" Proizvodi ")
                ])),
                _: 1
              }),
              (_ctx.isLoggedIn)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: "/create-product",
                    class: "bg-indigo-600 hover:bg-indigo-700 text-white px-2 py-2 rounded-md text-xs font-medium transition-colors flex items-center space-x-1 flex-shrink-0 whitespace-nowrap"
                  }, {
                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        class: "h-4 w-4",
                        viewBox: "0 0 20 20",
                        fill: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "fill-rule": "evenodd",
                          d: "M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z",
                          "clip-rule": "evenodd"
                        })
                      ], -1),
                      _createElementVNode("span", null, "Dodaj novi oglas", -1)
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createElementVNode("main", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          (_ctx.isInitialized)
            ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
            : (_openBlock(), _createElementBlock("div", _hoisted_14, _cache[9] || (_cache[9] = [
                _createElementVNode("div", { class: "text-white" }, "Učitavanje...", -1)
              ])))
        ])
      ]),
      _createVNode(_component_AppFooter, { class: "relative z-50" })
    ], 2)
  ]))
}